export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL'
export const USER_LOGIN_RESET = 'USER_LOGIN_RESET'
export const USER_LOGOUT = 'USER_LOGOUT'
export const USER_LOGOUT_REQUEST = 'USER_LOGOUT_REQUEST'
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS'
export const USER_LOGOUT_FAIL = 'USER_LOGOUT_FAIL'
export const USER_LOGOUT_RESET = 'USER_LOGOUT_RESET'

export const GET_ROLE_REQUEST = 'GET_ROLE_REQUEST'
export const GET_ROLE_SUCCESS = 'GET_ROLE_SUCCESS'
export const GET_ROLE_FAIL = 'GET_ROLE_FAIL'
export const GET_ROLE_RESET = 'GET_ROLE_RESET'

export const ADD_USER_REQUEST = 'ADD_USER_REQUEST'
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS'
export const ADD_USER_FAIL = 'ADD_USER_FAIL'
export const ADD_USER_RESET = 'ADD_USER_RESET'

export const GET_USERS_REQUEST = 'GET_USERS_REQUEST'
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS'
export const GET_USERS_FAIL = 'GET_USERS_FAIL'
export const GET_USERS_RESET = 'GET_USERS_RESET'

export const GET_USER_BY_ID_REQUEST = 'GET_USER_BY_ID_REQUEST'
export const GET_USER_BY_ID_SUCCESS = 'GET_USER_BY_ID_SUCCESS'
export const GET_USER_BY_ID_FAIL = 'GET_USER_BY_ID_FAIL'
export const GET_USER_BY_ID_RESET = 'GET_USER_BY_ID_RESET'

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_FAIL = 'UPDATE_USER_FAIL'
export const UPDATE_USER_RESET = 'UPDATE_USER_RESET'

export const RESET_DEVICE_ID_REQUEST = 'RESET_DEVICE_ID_REQUEST'
export const RESET_DEVICE_ID_SUCCESS = 'RESET_DEVICE_ID_SUCCESS'
export const RESET_DEVICE_ID_FAIL = 'RESET_DEVICE_ID_FAIL'
export const RESET_DEVICE_ID_RESET = 'RESET_DEVICE_ID_RESET'

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL'
export const RESET_PASSWORD_RESET = 'RESET_PASSWORD_RESET'

export const REMOVE_CUSTOMER_FROM_USER_REQUEST =
  'REMOVE_CUSTOMER_FROM_USER_REQUEST'
export const REMOVE_CUSTOMER_FROM_USER_SUCCESS =
  'REMOVE_CUSTOMER_FROM_USER_SUCCESS'
export const REMOVE_CUSTOMER_FROM_USER_FAIL = 'REMOVE_CUSTOMER_FROM_USER_FAIL'
export const REMOVE_CUSTOMER_FROM_USER_RESET = 'REMOVE_CUSTOMER_FROM_USER_RESET'

export const ADD_CUSTOMER_TO_USER_REQUEST = 'ADD_CUSTOMER_TO_USER_REQUEST'
export const ADD_CUSTOMER_TO_USER_SUCCESS = 'ADD_CUSTOMER_TO_USER_SUCCESS'
export const ADD_CUSTOMER_TO_USER_FAIL = 'ADD_CUSTOMER_TO_USER_FAIL'
export const ADD_CUSTOMER_TO_USER_RESET = 'ADD_CUSTOMER_TO_USER_RESET'

export const FETCH_ATTENDANCE_REQUEST = 'FETCH_ATTENDANCE_REQUEST'
export const FETCH_ATTENDANCE_SUCCESS = 'FETCH_ATTENDANCE_SUCCESS'
export const FETCH_ATTENDANCE_FAIL = 'FETCH_ATTENDANCE_FAIL'
export const FETCH_ATTENDANCE_RESET = 'FETCH_ATTENDANCE_RESET'

export const RESIGN_USER_REQUEST = 'RESIGN_USER_REQUEST'
export const RESIGN_USER_SUCCESS = 'RESIGN_USER_SUCCESS'
export const RESIGN_USER_FAIL = 'RESIGN_USER_FAIL'
export const RESIGN_USER_RESET = 'RESIGN_USER_RESET'

export const FORCE_LOGOUT_USER_REQUEST = 'FORCE_LOGOUT_USER_REQUEST'
export const FORCE_LOGOUT_USER_SUCCESS = 'FORCE_LOGOUT_USER_SUCCESS'
export const FORCE_LOGOUT_USER_FAIL = 'FORCE_LOGOUT_USER_FAIL'
export const FORCE_LOGOUT_USER_RESET = 'FORCE_LOGOUT_USER_RESET'

export const FORCE_LOGOUT_MULTIPLE_REQUEST = 'FORCE_LOGOUT_MULTIPLE_REQUEST'
export const FORCE_LOGOUT_MULTIPLE_SUCCESS = 'FORCE_LOGOUT_MULTIPLE_SUCCESS'
export const FORCE_LOGOUT_MULTIPLE_FAIL = 'FORCE_LOGOUT_MULTIPLE_FAIL'
export const FORCE_LOGOUT_MULTIPLE_RESET = 'FORCE_LOGOUT_MULTIPLE_RESET'

export const CHECK_USER_REQUEST = 'CHECK_USER_REQUEST'
export const CHECK_USER_SUCCESS = 'CHECK_USER_SUCCESS'
export const CHECK_USER_FAIL = 'CHECK_USER_FAIL'

export const SEND_OTP_REQUEST = 'SEND_OTP_REQUEST'
export const SEND_OTP_SUCCESS = 'SEND_OTP_SUCCESS'
export const SEND_OTP_FAIL = 'SEND_OTP_FAIL'

export const VERIFY_OTP_REQUEST = 'VERIFY_OTP_REQUEST'
export const VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS'
export const VERIFY_OTP_FAIL = 'VERIFY_OTP_FAIL'

export const GET_AFFILIATE_STATS_REQUEST = 'GET_AFFILIATE_STATS_REQUEST'
export const GET_AFFILIATE_STATS_SUCCESS = 'GET_AFFILIATE_STATS_SUCCESS'
export const GET_AFFILIATE_STATS_FAIL = 'GET_AFFILIATE_STATS_FAIL'

export const GET_AFFILIATE_REFERRALS_REQUEST = 'GET_AFFILIATE_REFERRALS_REQUEST'
export const GET_AFFILIATE_REFERRALS_SUCCESS = 'GET_AFFILIATE_REFERRALS_SUCCESS'
export const GET_AFFILIATE_REFERRALS_FAIL = 'GET_AFFILIATE_REFERRALS_FAIL'

export const GET_AFFILIATE_EARNINGS_REQUEST = 'GET_AFFILIATE_EARNINGS_REQUEST'
export const GET_AFFILIATE_EARNINGS_SUCCESS = 'GET_AFFILIATE_EARNINGS_SUCCESS'
export const GET_AFFILIATE_EARNINGS_FAIL = 'GET_AFFILIATE_EARNINGS_FAIL'